import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { FormRunner } from "@/components/forms/FormRunner";
import { SafetyMessage } from "@/components/SafetyMessage";
import { ImportantNote } from "@/components/ImportantNote";

export default function CareIntakePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [safety, setSafety] = useState(null);

  const done = () => { qc.invalidateQueries({ queryKey: ["portal"] }); navigate("/portal"); };
  const onSubmitted = (result) => {
    qc.invalidateQueries({ queryKey: ["portal"] });
    if (result.safety) { setSafety(result.safety); return; }
    toast.success("Thank you. Your Care Intake is complete.");
    navigate("/portal");
  };

  if (!user.email_verified) {
    return (
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6" data-testid="care-intake-locked">
        <h1 className="text-4xl">Care Intake</h1>
        <div className="surface mt-8 max-w-xl p-6">
          <p className="font-serif text-xl font-semibold">Please Confirm Your Email First</p>
          <p className="mt-2">We sent a confirmation link to {user.email}. Once it is confirmed, you can complete your Care Intake here.</p>
          <Link to="/portal" className="btn-secondary mt-5">Back To My Care Journey</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6" data-testid="care-intake-page">
      {safety && <SafetyMessage lines={safety.lines} onDismiss={done} />}
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <h1 className="text-4xl sm:text-5xl">Care Intake</h1>
          <p className="mt-3 text-ink-500 max-w-[55ch]">Basic information about you and your counseling needs. Your answers save as you go, so you can finish later.</p>
          <div className="mt-10"><FormRunner templateKey="care_intake" onSubmitted={onSubmitted} /></div>
        </div>
        <div className="lg:col-span-5"><ImportantNote /></div>
      </div>
    </div>
  );
}
